// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.patient-entered-notes {
	padding: 0 16px;
}

.patient-entered-notes p {
	margin-top: 16px;
	margin-bottom: 16px;
}

.patient-entered-notes.editable {
	min-height: 50px;
	position: relative;
}

.patient-entered-notes .textarea-wrapper {
	margin-right: 30px;
}

.patient-entered-notes textarea {
	width: 100%;
	font-size: 15px;
	padding: 12px 0;
	margin: 1px 0 0;
	border: none;
	box-sizing: border-box;
	overflow: hidden;
	display: block;
	font-family: "Helvetica Neue", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}

.patient-entered-notes .edit-icon {
	font-size: 16px;
	position: absolute;
	top: 10px;
	right: 22px;
}`, "",{"version":3,"sources":["webpack://./src/widgets/MyDataHelps/Dashboard/PatientEnteredNotes.css"],"names":[],"mappings":"AAAA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,eAAe;CACf,eAAe;CACf,YAAY;CACZ,sBAAsB;CACtB,gBAAgB;CAChB,cAAc;CACd,oKAAoK;AACrK;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,SAAS;CACT,WAAW;AACZ","sourcesContent":[".patient-entered-notes {\n\tpadding: 0 16px;\n}\n\n.patient-entered-notes p {\n\tmargin-top: 16px;\n\tmargin-bottom: 16px;\n}\n\n.patient-entered-notes.editable {\n\tmin-height: 50px;\n\tposition: relative;\n}\n\n.patient-entered-notes .textarea-wrapper {\n\tmargin-right: 30px;\n}\n\n.patient-entered-notes textarea {\n\twidth: 100%;\n\tfont-size: 15px;\n\tpadding: 12px 0;\n\tmargin: 1px 0 0;\n\tborder: none;\n\tbox-sizing: border-box;\n\toverflow: hidden;\n\tdisplay: block;\n\tfont-family: \"Helvetica Neue\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n}\n\n.patient-entered-notes .edit-icon {\n\tfont-size: 16px;\n\tposition: absolute;\n\ttop: 10px;\n\tright: 22px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
